<template>
    <kt-row>
        <kt-col lg="6" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="merchant_number">
                    {{ $t('label.merchant_number') }}
                </kt-form-label>
                <kt-form-control
                        id="merchant_number"
                        name="merchant_number"
                        v-model="psp_request.merchant_number"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="6" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="terminal_number">
                    {{ $t('label.terminal_number') }}
                </kt-form-label>
                <kt-form-control
                        id="terminal_number"
                        name="terminal_number"
                        v-model="psp_request.terminal_number"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="6" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="certificate">
                    {{ $t('label.certificate') }}
                </kt-form-label>
                <kt-form-label for="certificate" class="d-block btn btn-secondary btn-wide label-file">
                    <kt-icon type="fa" name="paperclip"></kt-icon>
                    {{ $t('btn.select_cert_file') }}
                </kt-form-label>
                <input
                        @change="processCertFile"
                        type="file"
                        class="custom-file-upload"
                        name="certificate"
                        id="certificate"
                        accept="text/xml"
                />
            </kt-form-group>
        </kt-col>
    </kt-row>
</template>

<script>
export default {
    props: {
        psp_request: {
            required: true,
            type: Object,
            default() {
                return {}
            }
        }
    },
    methods:{
        processCertFile(e){
            this.psp_request.certificate = event.target.files[0]
        },
    },
}
</script>

<style scoped>
    .label-file {
        border: 1px solid #ccc;
        width: fit-content;
        cursor: pointer;
        min-width: 200px;
    }
    input[type="file"]::-webkit-file-upload-button {
        visibility: hidden;
    }
</style>